type AvailabilitySwitchProps = {
	checked: boolean;
	onToggle: () => void;
	disabled?: boolean;
	ariaLabel?: string;
	labelOn?: string;
	labelOff?: string;
};

export function AvailabilitySwitch({
	checked,
	onToggle,
	disabled = false,
	ariaLabel,
	labelOn = "Disponible",
	labelOff = "No disponible",
}: AvailabilitySwitchProps) {
	return (
		<div className='inline-flex items-center gap-3 text-sm text-slate-700'>
			<button
				type='button'
				disabled={disabled}
				aria-label={ariaLabel}
				title={ariaLabel}
				onClick={onToggle}
				className={
					"relative inline-flex h-6 w-10 items-center rounded-full border border-border p-0.5 transition-colors duration-300 " +
					(checked ? "bg-primary" : "bg-slate-200") +
					(disabled ? " cursor-not-allowed opacity-60" : " cursor-pointer")
				}
			>
				<span
					className={
						"inline-block h-5 w-5 rounded-full bg-white shadow transition-transform duration-300 " +
						(checked ? "translate-x-4" : "translate-x-0")
					}
				/>
			</button>
			<span
				className={
					checked
						? "text-xs font-semibold text-primary"
						: "text-xs font-semibold text-text-placeholder"
				}
			>
				{checked ? labelOn : labelOff}
			</span>
		</div>
	);
}
